/**
 * Shared colours for leave types across charts (bar, pie, etc.).
 */

export const LEAVE_TYPE_COLORS: Record<string, string> = {
  'Annual': '#2e7d32',
  'Annual Leave': '#2e7d32',
  'Family Responsibility': '#0288d1',
  'Family Responsibility Leave': '#0288d1',
  'Sick': '#ed6c02',
  'Sick Leave': '#ed6c02',
  'Study': '#00695c',
  'Study Leave': '#00695c',
  'Microsoft Exam Leave': '#00695c',
  'Special': '#5e35b1',
  'Special / Other': '#5e35b1',
  'TOIL': '#795548',
  'Time off in Lieu': '#795548',
  'Parental': '#00897b',
  'Parental Leave': '#00897b',
  'Other': '#9e9e9e',
};

export function getLeaveTypeColor(leaveType: string): string {
  return (
    LEAVE_TYPE_COLORS[leaveType] ??
    LEAVE_TYPE_COLORS[leaveType.replace(/\s+Leave$/, '')] ??
    LEAVE_TYPE_COLORS['Other']
  );
}
